export default function getScoreSeverity(score: number, precision = 1) {
    if (score >= 7 * precision) {
        return 'High';
    }
    if (score >= 4 * precision) {
        return 'Medium';
    }
    return 'Low';
}
